import { useTranslation } from 'react-i18next';

export const keyPrefix = 'user_permission_tag_list';
export const useUserPermissionTagListTranslation = () => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Теги доступа',
    button_expand: 'Раскрыть все',
    button_collapse: 'Свернуть все',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Access tags',
    button_expand: 'Expand all',
    button_collapse: 'Collapse all',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Etiquetas de acceso',
    button_expand: 'Expandir todo',
    button_collapse: 'Colapsar todo',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Tags de acesso',
    button_expand: 'Expandir tudo',
    button_collapse: 'Colapsar tudo',
  },
}) as Record<string, unknown>;
